import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    validateBarrierNameId,
    validateCourseDescription,
    validateHealthInformationIds,
    validateModuleDescription,
    validateModuleTemplateSessionData,
    validateModuleTemplatesNumber,
    validateSessionNumber,
    validateSmartTargetAction,
    validateSmartTargetName,
    validateUniqueNames
} from '../utils/validationFunctions';

export const validate = (newEntry, singleModule, initialEntry) => {
    let newErrors = {};

    newErrors = validateCourseDescription(newEntry.description, newErrors);

    if (newEntry.healthInformationCaptured)
        newErrors = validateHealthInformationIds(newEntry.healthInformationIds, newErrors);
    if (newEntry.modularCourse) {
        newErrors = validateModuleTemplatesNumber(newEntry.moduleTemplates, newErrors);
        newErrors = validateUniqueNames(newEntry.moduleTemplates, newErrors);
        if (newEntry.sessionBased)
            newErrors = validateModuleTemplateSessionData(newEntry.moduleTemplates, newErrors);
    } else {
        newErrors = validateModuleDescription(singleModule.description, newErrors);
        if (newEntry.sessionBased)
            newErrors = validateSessionNumber(singleModule.sessionNumber, newErrors);

        if (singleModule.smartTarget) {
            newErrors = validateSmartTargetName(singleModule.smartTarget.name, newErrors);
            newErrors = validateBarrierNameId(singleModule.smartTarget.barrierNameId, newErrors);
            newErrors = validateSmartTargetAction(singleModule.smartTarget.action, newErrors);
        }
    }

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialEntry);
    return newErrors;
};
